import { useCallback, useState } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { useStore } from '../hooks/useStore';
import { useEventBus } from '../hooks/useEventBus';
import { CloseIcon } from '../icons';
import styles from './HotkeysOverlay.module.css';

interface HotkeyRowProps {
  action: string;
  keys: string[];
}

function HotkeyRow({ action, keys }: HotkeyRowProps) {
  return (
    <div className={styles.row}>
      <span className={styles.action}>{action}</span>
      <span className={styles.keys}>
        {keys.map((key, i) => (
          <kbd key={`${key}-${i}`} className={styles.key}>{key}</kbd>
        ))}
      </span>
    </div>
  );
}

export function HotkeysOverlay() {
  const { store, eventBus } = usePlayerContext();
  const clipsAvailable = useStore(store, useCallback(s => s.clipsAvailable, []));
  const [isVisible, setIsVisible] = useState(false);

  useEventBus(eventBus, 'hotkeys:open', useCallback(() => {
    setIsVisible(true);
  }, []));

  const handleClose = useCallback(() => {
    setIsVisible(false);
  }, []);

  const handleOverlayClick = useCallback(() => {
    setIsVisible(false);
  }, []);

  const handlePanelClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  if (!isVisible) return null;

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.panel} onClick={handlePanelClick}>
        <div className={styles.headerRow}>
          <span className={styles.title}>Горячие клавиши</span>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={handleClose}
            aria-label="Закрыть"
          >
            <CloseIcon />
          </button>
        </div>
        <div className={styles.list}>
          <HotkeyRow action="Воспроизвести/Пауза" keys={['Пробел', 'k']} />
          <HotkeyRow action="Звук вкл./откл." keys={['m']} />
          <HotkeyRow action="Громкость +10%/-10%" keys={['↑', '↓']} />
          <HotkeyRow action="Плеер в окне" keys={['i']} />
          <HotkeyRow action="Консоль" keys={['~']} />
          {clipsAvailable && (
            <HotkeyRow action="Создать клип" keys={['Alt + x']} />
          )}
          <HotkeyRow action="Театральный режим" keys={['Alt + t']} />
          <HotkeyRow action="На весь экран вкл./откл." keys={['f']} />
        </div>
      </div>
    </div>
  );
}
